import type { PiiLookupDocumentDto } from "@babackapp/private-api-client/generated/schema";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@babackapp/ui/components/table";
import { format } from "date-fns";
import { PiiDocumentJsonDialog } from "./pii-document-json-dialog";
import { PiiStatusCell } from "./pii-status-cell";

const kindLabels: Record<string, string> = {
  order: "Commande",
  parcel: "Colis",
};

/** Orders and parcels: a row click opens a raw JSON dialog, no dedicated page here. */
export function PiiOrdersParcelsTable({
  documents,
}: {
  documents: PiiLookupDocumentDto[];
}) {
  return (
    <div className="max-h-80 overflow-y-auto border rounded-md">
      <Table>
        <TableHeader className="sticky top-0 bg-background">
          <TableRow>
            <TableHead>Type</TableHead>
            <TableHead>Référence</TableHead>
            <TableHead>Créé le</TableHead>
            <TableHead>Statut</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {documents.map((document) => (
            <PiiDocumentJsonDialog
              key={document.id}
              document={document}
              trigger={
                <TableRow className="cursor-pointer">
                  <TableCell>{kindLabels[document.kind]}</TableCell>
                  <TableCell>{document.reference}</TableCell>
                  <TableCell>
                    {format(new Date(document.createdAt), "dd/MM/yyyy HH:mm")}
                  </TableCell>
                  <TableCell>
                    <PiiStatusCell document={document} />
                  </TableCell>
                </TableRow>
              }
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
